import { useContext, useEffect, useState } from "react";

import DashboardService from "../services/api";
import { MonthlyBarChart } from "../components/Graph/MonthlyBarChart";
import CardWithTable from "../components/Container/CardWithTable";
import FourBarContainer from "../components/Container/FourBarContainer";
import { appContext } from "../Context/AppContext";
import { DateTime } from "luxon";

export const TherapySessions = () => {
  const { department, location, fromDate, toDate,monthValue } = useContext(appContext);
  const localData =
    localStorage.getItem("userdata") || JSON.stringify({ accessCode: "" });
  const access_code = JSON.parse(localData).accessCode;
  const [monthlyData, setMonthlyData] = useState([]);
  const [moduleArray, setModuleArray] = useState<any>([]);
  const [blogsArray, setBlogsArray] = useState<any>([]);
  const [total, setTotal] = useState(0);
  const [barData, setBarData] = useState<any>({});
  const calculatePercentage = (total: any, data: any) => {
    const result = [];

    for (const item of data) {
      const percentage = Math.round((item.count / total) * 100) || 0;
      result.push({ name: item._id, percentage });
    }
    console.log("result",result);
    return result;
  };
  const fetchData = async () => {
    DashboardService.getBookingsData(
      access_code,
      department,
      location,
      fromDate,
      toDate
    )
      .then((res: any) => {
        const data = res.data;
        console.log(data);
        setTotal(data.total_booking);
        setMonthlyData(data.monthCount);
        setBarData({
          bar1: data.completed,
          bar2: data.rescheduled,
          bar3: data.cancelled,
          bar4: data.upcoming,
        });
        setModuleArray(calculatePercentage(data.total_booking, data.weekCount));
        setBlogsArray(calculatePercentage(data.total_booking, data.typeCount));
      })
      .catch((e) => {
        console.log(e);
      });
  };

  function getMonthName(dateString: string) {
    const date = DateTime.fromISO(dateString);
    return date.toFormat("MMMM");
  }

  useEffect(() => {
    fetchData();
  }, [department, location,fromDate]);
  return (
    <div>
      <h1 style={{ padding: "25px", backgroundColor: "#fff" }}>
        Therapy Sessions
      </h1>
      {monthlyData.length > 0 && (
        <div
          style={{
            padding: "0 15px",
            backgroundColor: "#fff",
            marginLeft: "15px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "15px 0",
            }}
          >
            <div style={{ fontSize: "20px" }}>Session booked over {monthValue?`${getMonthName(monthValue)} Month`:"last 30 days"}</div>
          </div>
          <div className="chart-container">
            {" "}
            <MonthlyBarChart data={monthlyData} />{" "}
          </div>
        </div>
      )}
      {monthlyData.length > 0 && (
        <div
          style={{
            padding: "0 15px",
            backgroundColor: "#fff",
            marginLeft: "15px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "15px 0",
            }}
          >
            <div style={{ fontSize: "20px" }}>Consultation</div>
          </div>
          {monthlyData.length > 0 && (
            <FourBarContainer
              total={total}
              bar1={barData.bar1}
              bar2={barData.bar2}
              bar3={barData.bar3}
              bar4={barData.bar4}
            />
          )}
        </div>
      )}

      {monthlyData.length > 0 && (
        <div className="card-container">
          <CardWithTable title={"Day"} data={moduleArray} type={"module"} />
          <CardWithTable title={"Session Mode"} data={blogsArray} type={"module"} />
        </div>
      )}
    </div>
  );
};
